import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { compose, withHandlers, lifecycle, withState } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { isAuthenticated, sendLogin } from '../../auth/Auth';
import { getAccounts } from '../../actions/Accounts';
import { createSecretMenu } from '../../actions/GochiMenus';
import '../../stylesheets/csv.css';
import ProgressDialog from '../../components/molecules/ProgressDialog';

const styles = {
  root: {
    backgroundColor: '#e0e0e0',
    flexGrow: 1,
    width: '100%'
  }
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account
    }),
    dispatch => ({
      actions: bindActionCreators({ getAccounts, createSecretMenu }, dispatch)
    })
  ),
  withState('enableBtn', 'setEnableBtn', true),
  withState('openProgress', 'updateOpenProgress', false),
  withState('loading', 'updateLoading', false),
  withState('loading', 'updateLoading', false),
  withState('resultMessage', 'setResultMessage', ''),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleRedirect: props => path => {
      props.history.push(path);
    }
  }),
  lifecycle({
    componentDidMount() {
      isAuthenticated(this.props);
      this.props.actions.getAccounts({ cognitoUserId: '' }).then(async data => {
        this.props.checkSession(data);
      });
    }
  })
);

const Main = enhance(
  ({
    actions,
    enableBtn,
    setEnableBtn,
    openProgress,
    loading,
    resultMessage,
    updateOpenProgress,
    updateLoading,
    setResultMessage,
    checkSession
  }) => {
    const onClickAction = async () => {
      setEnableBtn(false);
      updateLoading(true);
      updateOpenProgress(true);

      const response = await actions
        .createSecretMenu()
        .then(data => checkSession(data));
      if (response.type === 'CREATE_SECRET_GOCHI_MENU_SUCCESS') {
        updateLoading(false);
        setResultMessage('Create secret menu succsessfully');
      } else {
        updateLoading(false);
        setResultMessage('Create secret menu fail');
      }
    };
    const progressOkAction = () => {
      updateOpenProgress(false);
      setEnableBtn(true);
    };
    return (
      <div className="box-create">
        <h2>Create Secret Menu</h2>
        <br />
        <br />

        <Button
          variant="contained"
          color="primary"
          onClick={onClickAction}
          disabled={!enableBtn}
          size="large"
        >
          Create Secret Menu
        </Button>

        <ProgressDialog
          openProgress={openProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
